import { useEffect } from 'react';

import { ModePrevModel } from '../PrevMedia';

interface KeyPressProps {
    targetKey: string;
    onHideModal: () => void;
    mode: ModePrevModel;
}

export const useKeyPress = ({ targetKey, onHideModal, mode }: KeyPressProps) => {
    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === targetKey && mode === null) {
                onHideModal();
            }
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [targetKey, onHideModal, mode]);
};
